$(document).ready(function(){
  
  
  jQuery(document).ready( function() {
    jQuery(".sbSubmenuWrapper").on('click', function() {
      if($(window).width() <= 768){
        $(this).find("nav").slideToggle();     
      }
    });
//     $(".brands_menu .switcher").click(function(){
//       $("ul.brandsSubmenu").slideToggle();
//       $(this).find(".switcher-open,.switcher-close").toggle();
//     });
//     $(".products_menu .switcher").click(function(){
//       $("ul.productSubmenu").slideToggle();
//       $(this).find(".switcher-open,.switcher-close").toggle();
//     }); 
  });
  
  jQuery(".faqWrapper .faq_question").on('click', function() {
    jQuery(this).next().slideToggle();
  });
  

  
  jQuery(".brandsSubmenu li a").each( function() {
    if(jQuery(this).attr('href') == '/collections/elemis') {
    	jQuery(this).hide().addClass('added_by_js');
    }
  });
  
//   alert($(window).width());
  /***Detect Ipad***/
function isiPad(){
    return (
      //Detect iPod
        (navigator.userAgent.match(/iPad/i) != null)
    );
}
if(isiPad()){
    jQuery("body").addClass("ipad-platform");
     $("*").on("click", function(){});
    jQuery(".z-images").on('click','img',function(){
        $('.z-focus').fadeIn().addClass('disabled');
  });
}
/**Detect iphone**/
function isiPhone(){
    return (
        (navigator.platform.indexOf("iPhone") != -1) ||
        (navigator.platform.indexOf("iPod") != -1)
    );
}
  

/*$(".caroufredsel_wrapper").swipe({
 tap: function(event, target) {
                alert('tap');
            },
  swipeLeft: function() {
    $('.caroufredsel_wrapper').trigger('next', 4);
    alert('0');
  },
  swipeRight: function() {
    $('.caroufredsel_wrapper').trigger('prev', 4);
  },
  tap: function(event, target) {
 	 window.open($(target).closest('a').attr('href'), '_self');
  }
    
});*/
  
if(isiPhone()){
   jQuery("body").addClass("iphone-platform");   

}
  
if(navigator.userAgent.indexOf('Android') > 0 || navigator.userAgent.indexOf('iPhone') > 0 || navigator.userAgent.indexOf('Windows Phone') > 0){
        $('body').addClass('mobile');        
    }

  if($(".sbSubmenuWrapper nav ul.sbSubcategories").length <= 0){
     $(".sbSubmenuWrapper h1").addClass("noSubNav");
        
     }
  
  
equaliseHeight('.hp_bottom_section .column');
equaliseHeight('.hp_bottom_section2 .column');
equaliseHeight('.hpFifthRow.collection_page .hpFifthRowColumn');
  
  function equaliseHeight(ra){
        var maxheight = "0px";	
          jQuery(ra).each(function () {
            jQuery(this).css("height", "auto");
            maxheight = (jQuery(this).css("height") > maxheight ? jQuery(this).css("height") : maxheight);              
          });

          jQuery(ra).css("height", maxheight);
                  
  }	
  
  	jQuery(" div > div > p:nth-child(1) > a:nth-child(7), #page-2557").before('<br class="footer_separator"/>');
  
  
  //add to cart button on cart page
  $('#addTBtoCartFromCheckout').click(function(e){
    e.preventDefault();
    
    $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: {quantity:1,id: 803012685},
        success: function() {
           location.reload();
        },
        error: Shopify.onError
      });
    
  });
  
  
$('div.bioSecondPart').hide();
  $('#bioReadLess').hide();
  
  $('#bioReadMore').click(function(e){
    $('div.bioSecondPart').slideDown();
    $('#bioReadMore').hide();
    $('#bioReadLess').show();
    e.preventDefault();
  });
  
  $('#bioReadLess').click(function(e){
    $('div.bioSecondPart').slideUp();
    $('#bioReadMore').show();
    $('#bioReadLess').hide();
    e.preventDefault();
  
  });  
  
  
// if(jQuery(".countryDescription p").height() > 57){
//  jQuery(".countryDescription p").addClass("toggle_part");
//  jQuery("#readmore").show();
// }else{
//  jQuery(".countryDescription p").removeClass("toggle_part");
//  jQuery("#readmore").hide();
// }  
  
  
//$('div.categoryDescription p.toggle_part').css("height","50px");
  $('.btn_read_less').hide();
var clickFlag = 0;  
      $('.btn_read_more').click(function(e){
	clickFlag = 1;
    var cgd = jQuery(".categoryDescription p.toggle_part,.countryDescription p.cdDesc.toggle_part, .toggle_part1");
    cgd.css("height","auto");       
    $('.btn_read_more').hide();
    $('.btn_read_less').show();
    e.preventDefault();
  });
  
  $('.btn_read_less').click(function(e){
    clickFlag = 0;
    var cgd = jQuery(".categoryDescription p,.countryDescription p.cdDesc, .toggle_part1");    
    //console.log("rm >>> " + cgd.html());
    if(cgd.length > 0){      
      var cgdLh = Math.round(cgd.css("line-height").split("px")[0]);
    }
    cgd.height(cgdLh * 3);    
    $('.btn_read_more').show();
    $('.btn_read_less').hide();
    $('.toggle_part1').css('height','60px');
    e.preventDefault();  
  });  
  
 // [Concatenate Collection Description Paragraphs for Read More Collapsible]
	//console.log("READY");
  var description = [];
  jQuery(" .categoryDescription p").each( function() {
    description.push(jQuery(this).html());  
  });
  //console.log(description);
  var textBlock = description.join('');
  //console.log(textBlock);
  
  jQuery("body#collection .categoryDescription p").remove();
  jQuery("body#collection #readmore").before('<p class="toggle_part">' + textBlock + '</p>');
  if(jQuery("body#collection .categoryDescription p").height() > 60) {
    jQuery("body#collection #readmore").show();
    jQuery("body#collection .categoryDescription p").height('60px');
  }
  else {
    jQuery("#readmore").hide();
  }
  
  jQuery('.categoryDescription').css('max-height','initial');

 // [/Concatenate Collection Description Paragraphs for Read More Collapsible]
  
  if( textBlock == []) {
  var page_heading = jQuery(".categoryDescription h2").html();
    //console.log(">>> " + page_heading);
jQuery(".categoryDescription h2").remove();
    if( page_heading != undefined ) {
      jQuery(".categoryDescription").before('<h2>' + page_heading + '</h2>');
    }
var read_more = jQuery(".categoryDescription #readmore").remove();
jQuery(".categoryDescription").wrapInner('<p class="toggle_part">');
jQuery(".categoryDescription p").last().remove();
jQuery(".categoryDescription").append(read_more);
if(jQuery("body#collection .categoryDescription p").height() > 60) {
    jQuery("body#collection #readmore").show();
    jQuery("body#collection .categoryDescription p").height('60px');
  } 
  else {
    jQuery("#readmore").hide();
  }
$('.btn_read_more').click(function(e){
 clickFlag = 1;
    var cgd = jQuery(".categoryDescription p.toggle_part,.countryDescription p.cdDesc.toggle_part, .toggle_part1");
    cgd.css("height","auto");       
    $('.btn_read_more').hide();
    $('.btn_read_less').show();
    e.preventDefault();
  });
  
  $('.btn_read_less').click(function(e){
    clickFlag = 0;
    var cgd = jQuery(".categoryDescription p,.countryDescription p.cdDesc, .toggle_part1");    
    //console.log("rm >>> " + cgd.html());
    if(cgd.length > 0){      
      var cgdLh = Math.round(cgd.css("line-height").split("px")[0]);
    }
    cgd.height(cgdLh * 3);    
    $('.btn_read_more').show();
    $('.btn_read_less').hide();
    $('.toggle_part1').css('height','60px');
    e.preventDefault();  
  });
  
    jQuery(window).resize( function() {
  
    if(jQuery('.btn_read_less').is(':visible') && clickFlag !=0 && jQuery(".toggle_part").height() > 60) {
    cgd.css("height","auto");       
    $('.btn_read_more').hide();
    $('.btn_read_less').show();
    }
    

  });
    
  }
//     var owl = $("#owl-demo");
     
//     owl.owlCarousel({
//     items : 10, //10 items above 1000px browser width
//     itemsDesktop : [1000,5], //5 items between 1000px and 901px
//     itemsDesktopSmall : [900,3], // betweem 900px and 601px
//     itemsTablet: [600,2], //2 items between 600 and 0
//     itemsMobile : false // itemsMobile disabled - inherit from itemsTablet option
//     });
     
//     // Custom Navigation Events
//     $(".next").click(function(){
//     owl.trigger('owl.next');
//     })
//     $(".prev").click(function(){
//     owl.trigger('owl.prev');
//     })
//     $(".play").click(function(){
//     owl.trigger('owl.play',1000); //owl.play event accept autoPlay speed as second parameter
//     })
//     $(".stop").click(function(){
//     owl.trigger('owl.stop');
//     })

  
  
  
    $(".tf_upfront_badge").click(function(){
        $(".overlay,#tf_upfront_badge div.tf_upfront_badge_closebutton").fadeIn()
        var popWrapper = $(".popup-wrapper");
        popupCenter(popWrapper);        
        popWrapper.fadeIn();
    });
    $("#tf_upfront_badge div.tf_upfront_badge_closebutton,.overlay").click(function(){
        $(".overlay,#tf_upfront_badge div.tf_upfront_badge_closebutton").fadeOut()
        $(".popup-wrapper").fadeOut(200, function(){          
        });
    });

    $(window).resize(function(){
        var popWrapper = $(".popup-wrapper");
        popupCenter(popWrapper);
      	equaliseHeight('.hp_bottom_section .column');
		equaliseHeight('.hp_bottom_section2 .column');
      equaliseHeight('.hpFifthRow.collection_page .hpFifthRowColumn');
    });
    function popupCenter(elem){        
        var marginTop = ($(window).height() - elem.height())/2;
        elem.css("margin-top", marginTop)
    }
 
  
// centers vertically the main menu items and the kit componenets names
  $('.menuDropdownTrigger').fadeIn("fast");
  $(".linkMainMenu").each(function(){
    var $content = $(this);
    var h = $content.outerHeight();
    $content.css('margin-top', + (36-h) / 2 + "px"); 
    //margin-top should be negative half of image height. This will center the image vertically when combined with position:absolute and top:50%.
  });
  
  var h1Width = $(".innerPageSubmenu h1").width();
  $(".submenuWrapper").css("margin-left", h1Width);
    $('.submenuWrapper').fadeIn("fast");



//product page images 
$(".thumbnailProductImage").click(function(){
  //alert ($(this).index());
  $( "img" ).removeClass( "activeThumb" );
  $( ".thumbsHolder img" ).addClass( "inactiveThumb" );
    var src = $(this).attr('data-bigImg');
  $(this).removeClass("inactiveThumb");
  $(this).addClass("activeThumb");
  $('#productBigImage').attr("src", src);
  $('div.addToCartInformation').css("background-color","transparent");
  $('div.productPageFormsWrapper form:eq('+$(this).index()+') div.addToCartInformation').css("background-color","#eee");
});

// product description tabs

var $productPagetabButtons = $('a#description,a#howToUse,a#ingredients,a#expertsTips');
$('div#howToUse-content,div#ingredients-content,div#expertsTips-content').hide();
var $productPagetabContent = $('div#description-content,div#howToUse-content,div#ingredients-content,div#expertsTips-content');

$productPagetabButtons.click(function(){
  $productPagetabButtons.removeClass('active');
  $(this).addClass('active');
  
  $productPagetabContent.hide();
  $('div#'+$(this).attr('id')+'-content').show();

  return false;
});
  
/***product description dropdown***/
  $(".tabsToggle").click(function() {
    $(".tabs").slideToggle();
});
$(".tabs a").click(function(event) {
    event.preventDefault();
    $(".tabsToggle span").html($(this).text());
    $(".tabsToggle span").css({
        color: "#E9C53A"
    });
    $(".dropdownTabs").slideUp();
});
var windowWidth = $('body').innerWidth();
if (windowWidth < 768) {
    $(".tabs").addClass("dropdownTabs");
}
if (windowWidth < 569) {
    $(".biography").addClass("toggle_part1");
}
$(window).resize(function() {
    var windowWidth = $('body').innerWidth();
    if (windowWidth < 768) {
        $(".biography").addClass("toggle_part1");
    } else $(".biography").removeClass("toggle_part1");
});

// function to turn newline into paragraphs
function p(t){
    t = t.trim();
    return (t.length>0?'<p>'+t.replace(/[\r\n]+/,'</p><p>')+'</p>':null);
}

// apply function to each one of the tab fields (they are not rich text, only plain, and they need it)
$("div#howToUse-content,div#ingredients-content,div#expertsTips-content").each(function(){
  if ($(this).length) {
    $(this).html(p($(this).html()));
  };
});

// travel kit slideshow
$('#tkPageAddCosmeticBagLink').click(function(){
  $('.tkStep1').fadeOut("fast",function(){
     $('.tkStep2').fadeIn();
  });
  return false;
});

// main menu brands to dropdown conversion
$('li.brandsClose').click(function() {
  $('ul.brandsSubmenu').slideUp('slow');
});
$('div#brandsMenu>a').click(function() {
  $('.brandsSubmenu').slideToggle();
  return false;
  
});


  // old scripts from shopify tpl



   function addItem(form_id) {
      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        dataType: 'json',
        data: $('form#'+form_id).serialize(),
        success: Shopify.onSuccess,
        error: Shopify.onError
      });
   }
   trbSfyAddtoCartFormId = "";
   $(".addtocart").click(function(e){
   
      var elem = $(this);
      $(elem).prop("disabled", true);

      e.preventDefault();
      trbSfyAddtoCartFormId = elem.parents('form').attr('id');

      //alert(formId);
      addItem(trbSfyAddtoCartFormId);
     
   });
  
   function updateTRBCart(){ // called when an item is added to the cart
      jQuery.ajax({

        url: "/cart.json",
        dataType: "jsonp",
        success: function( data ) {
            var getTotalPrice = (data.total_price);
            var monetizeTotalPrice = Shopify.formatMoney(getTotalPrice, '{{amount}}')
            var getItemCount = (data.item_count);

            $('span#cart-count').text(getItemCount);
            $('span#total_price').text(monetizeTotalPrice); 
        },
        error: function( jxhr, status, err ) {
            //console.log("Error, status = " + status + ", err = " + err);
        }

      });
    }

   Shopify.onSuccess = function() {
     
      var elem = $('form#'+ trbSfyAddtoCartFormId + ' button.addtocart');
     
      elem.removeAttr("disabled");
     
      var quantity = parseInt(jQuery('form#'+trbSfyAddtoCartFormId+' select[name="quantity"] option:selected').val(), 10) || 1;

      //alert(quantity);

      $("html, body").animate({ scrollTop: 0 }, 250, 'swing');

      function animate() {

        var cartAnimation = $('form#'+ trbSfyAddtoCartFormId +' div.cart-animation');

        cartAnimation.show();

        var addtocartWidth = elem.outerWidth() / 2
        var addtocartHeight = elem.outerHeight() / 2

        var addtocartLeft = elem.offset().left + addtocartWidth;
        var addtocartTop = elem.offset().top + addtocartHeight ;

        var buttonAreaWidth = $("#cart-target").outerWidth();
        var buttonAreaHeight = $("#cart-target").outerHeight();

        var buttonAreaLeft = ($("#cart-target").offset().left + buttonAreaWidth / 2  - cartAnimation.outerWidth() / 2);
        var buttonAreaTop = ($("#cart-target").offset().top + buttonAreaWidth / 2  - cartAnimation.outerHeight() / 2);

        var path = {
          start: {
            x: addtocartLeft,
            y: addtocartTop,
            angle: 190.012,
            length: 0.2
          },
          end: {
            x: buttonAreaLeft,
            y: buttonAreaTop,
            angle: 90.012,
            length: 0.50
          }
        };
   
        cartAnimation.text(quantity).animate(
        {
          path : new $.path.bezier(path)
        },
        1200,
        function() {
          cartAnimation.fadeOut(500, function() {
            $(elem).prop("disabled", false)
            
            $('#cart-target').addClass('has-items');

            updateTRBCart();
          })
        }
        );
      }
      animate();  
    };
  
    Shopify.onError = function(XMLHttpRequest, textStatus) {
      // Shopify returns a description of the error in XMLHttpRequest.responseText.
      // It is JSON.
      // Example: {"description":"The product 'Amelia - Small' is already sold out.","status":500,"message":"Cart Error"}
      var data = eval('(' + XMLHttpRequest.responseText + ')');
      if (!!data.message) {
        alert(data.message + '(' + data.status  + '): ' + data.description);
      } else {
        alert('Error : ' + Shopify.fullMessagesFromErrors(data).join('; ') + '.');
      }

      $('.addtocart').removeAttr("disabled");
    };

    Shopify.fullMessagesFromErrors = function(errors) {
      var fullMessages = [];
      jQuery.each(errors, function(attribute, messages) {
        jQuery.each(messages, function(index, message) {
          fullMessages.push(attribute + ' ' + message);
        });
      });
      return fullMessages;
    };
  
  if(window.location.pathname.indexOf('yasmine') == 0) {
    jQuery(".sbSubmenuWrapper").on('click', function() {
      if($(window).width() <= 768){
        $(this).find("nav").slideToggle();     
      }
    });
  }

})

jQuery(window).load(function(){

  if ( $('.slides li').size() > 1 ) {

    $('.flexslider').flexslider({
      animation: "slide",
      slideshow: true,
      animationDuration: 700,
      slideshowSpeed: 6000,
      animation: "fade",
      controlsContainer: ".flex-controls",
      controlNav: false,
      keyboardNav: true
    }).hover(function(){ $('.flex-direction-nav').fadeIn();}, function(){$('.flex-direction-nav').fadeOut();});

  }

  $("select.loc_on_change").change(function(){
    if($(this).attr("value") == "#") return false;
    window.location = $(this).attr("value");
  });

  
});

jQuery(document).ready(function($){
 
  
}); // end document ready

/* jQuery css bezier animation support -- Jonah Fox */
 
;(function($){
 
  $.path = {};
 
  var V = {
    rotate: function(p, degrees) {
      var radians = degrees * Math.PI / 180,
        c = Math.cos(radians),
        s = Math.sin(radians);
      return [c*p[0] - s*p[1], s*p[0] + c*p[1]];
    },
    scale: function(p, n) {
      return [n*p[0], n*p[1]];
    },
    add: function(a, b) {
      return [a[0]+b[0], a[1]+b[1]];
    },
    minus: function(a, b) {
      return [a[0]-b[0], a[1]-b[1]];
    }
  };
 
  $.path.bezier = function( params, rotate ) {
    params.start = $.extend( {angle: 0, length: 0.3333}, params.start );
    params.end = $.extend( {angle: 0, length: 0.3333}, params.end );
 
    this.p1 = [params.start.x, params.start.y];
    this.p4 = [params.end.x, params.end.y];
 
    var v14 = V.minus( this.p4, this.p1 ),
      v12 = V.scale( v14, params.start.length ),
      v41 = V.scale( v14, -1 ),
      v43 = V.scale( v41, params.end.length );
 
    v12 = V.rotate( v12, params.start.angle );
    this.p2 = V.add( this.p1, v12 );
 
    v43 = V.rotate(v43, params.end.angle );
    this.p3 = V.add( this.p4, v43 );
 
    this.f1 = function(t) { return (t*t*t); };
    this.f2 = function(t) { return (3*t*t*(1-t)); };
    this.f3 = function(t) { return (3*t*(1-t)*(1-t)); };
    this.f4 = function(t) { return ((1-t)*(1-t)*(1-t)); };
 
    /* p from 0 to 1 */
    this.css = function(p) {
      var f1 = this.f1(p), f2 = this.f2(p), f3 = this.f3(p), f4=this.f4(p), css = {};
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( this.p1[0]*f1 + this.p2[0]*f2 +this.p3[0]*f3 + this.p4[0]*f4 +.5 )|0;
      css.y = this.y = ( this.p1[1]*f1 + this.p2[1]*f2 +this.p3[1]*f3 + this.p4[1]*f4 +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.path.arc = function(params, rotate) {
    for ( var i in params ) {
      this[i] = params[i];
    }
 
    this.dir = this.dir || 1;
 
    while ( this.start > this.end && this.dir > 0 ) {
      this.start -= 360;
    }
 
    while ( this.start < this.end && this.dir < 0 ) {
      this.start += 360;
    }
 
    this.css = function(p) {
      var a = ( this.start * (p ) + this.end * (1-(p )) ) * Math.PI / 180,
        css = {};
 
      if (rotate) {
        css.prevX = this.x;
        css.prevY = this.y;
      }
      css.x = this.x = ( Math.sin(a) * this.radius + this.center[0] +.5 )|0;
      css.y = this.y = ( Math.cos(a) * this.radius + this.center[1] +.5 )|0;
      css.left = css.x + "px";
      css.top = css.y + "px";
      return css;
    };
  };
 
  $.fx.step.path = function(fx) {
    var css = fx.end.css( 1 - fx.pos );
    if ( css.prevX != null ) {
      $.cssHooks.transform.set( fx.elem, "rotate(" + Math.atan2(css.prevY - css.y, css.prevX - css.x) + ")" );
    }
    fx.elem.style.top = css.top;
    fx.elem.style.left = css.left;
  };
 
})(jQuery);

$(function(){
  setTimeout(function(){
     $(".productCarousel").carouFredSel({
    width: "100%",
    height: 1070,
    scroll: {
      items: 1,
      duration: 300
      // onAfter: function( data ) {
      //   data.items.old.prev().find( 'img' ).lazyload();
      //   data.items.visible.next().find( 'img' ).lazyload();
      // }
    },
     onCreate: function( data ) {
        jQuery(".homepageCarouselWrapper .productCarousel").removeClass('sliderInitalizing');
      },
    auto  : false,
    prev  : "#hpc_prev",
    next  : "#hpc_next",    
    
    swipe: {
      onMouse: false,
      onTouch: true 
    },
    
    mousewheel: false
  });
  jQuery(".homepageCarouselWrapper,.products.bestSeller,.related_products.media .row").removeClass("carousel-load");
             }, 500);
   
  
  $(".productCarousel_bestSeller").carouFredSel({
    width: "100%",
    height: 1070,
    scroll: {
      items: 1,
      duration: 500
      // onAfter: function( data ) {
      //   data.items.old.prev().find( 'img' ).lazyload();
      //   data.items.visible.next().find( 'img' ).lazyload();
      // }
    },
    auto  : false,
    prev  : "#hpc_previous",
    next  : "#hpc_nxt",
    
    items: {
          visible: "variable"
    },
    swipe: {
      onMouse: false,
      onTouch: true
    },
    mousewheel: false
  });  

  
  
  
  //HomePageSlider
  
   $(".productCarousel_bestSellers").slick({
    infinite: true,
    slidesToShow: 4,
  	slidesToScroll: 1,
    arrows: true,
    prevArrow:'<a class="prev"><span>Prev</span></a>',
    nextArrow:'<a class="next"><span>Next</span></a>',
    responsive: [
    {
      breakpoint: 800,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
  });
 
  
  
  
  
 /*$(".productCarousel_relatedProduct").carouFredSel({
    width: "100%",
    height: 1070,
    scroll: {
      items: 1,
      duration: 500
      // onAfter: function( data ) {
      //   data.items.old.prev().find( 'img' ).lazyload();
      //   data.items.visible.next().find( 'img' ).lazyload();
      // }
    },
    auto  : false,
    prev  : "#hpc_previous_rp",
    next  : "#hpc_nxt_rp",
    
    items: {
          visible: "variable"
    },
    swipe: {
      onMouse: false,
      onTouch: true
    },
    mousewheel: false
  }); */
  
  $(".productCarousel_relatedProduct").slick({
    infinite: true,
    slidesToShow: 3,
  	slidesToScroll: 1,
     prevArrow:'<a class="prev"><span>Prev</span></a>',
    nextArrow:'<a class="next"><span>Next</span></a>',
    responsive: [
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
  });
  
  
  
  
  //HomePageSlider
  
   $(".homepPoductCarouselSlik").slick({
    infinite: true,
    slidesToShow: 3,
  	slidesToScroll: 1,
    arrows: true,
    prevArrow:'<a class="prev"><span>Prev</span></a>',
    nextArrow:'<a class="next"><span>Next</span></a>',
    responsive: [
    {
      breakpoint: 1026,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 500,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    }
  ]
  });
  
});   


$(document).ready( function() {
 
  $(".mobile_promo_bar").on('click','.trigger', function() {
  		var parent_container = $(".mobile_promo_bar");
    	var pc_height = parent_container.find("p").height();    
		parent_container.css("height",pc_height);
    	$(".trigger").addClass("expanded");
		$(".trigger").html("X");
  });

  $(".mobile_promo_bar").on('click','.expanded', function() {
  		$(".mobile_promo_bar").height(20);
    	$(".trigger").removeClass("expanded");
		$(".trigger").html("...");
  });
  
    $(".brands_menu .switcher").click(function(){
      $("ul.brandsSubmenu").slideToggle();
      $(this).find(".switcher-open,.switcher-close").toggle();
    });
    $(".products_menu .switcher").click(function(){
      $("ul.productSubmenu").slideToggle();
      $(this).find(".switcher-open,.switcher-close").toggle();
    });  
  readMoreInsertion();
  ra();
  jQuery(window).resize(function(){
  	readMoreInsertion();
    ra();
  });
});

function readMoreInsertion(){
  	var cgd = jQuery(".categoryDescription p,.countryDescription p.cdDesc");
  if(cgd.length > 0){
    //console.log(cgd.html());
  	cgd.css("height","auto");
	var cgdLh = Math.round(cgd.css("line-height").split("px")[0]);
  	var cgdH = cgd.height();
  	var numOfLines = Math.round(cgdH / cgdLh); 
    if(numOfLines > 3){
      jQuery("#readmore").show();
      cgd.addClass("toggle_part").height(3 * cgdLh);     
    }else{
      jQuery("#readmore").hide();
      cgd.removeClass("toggle_part").css("height","auto");
    }
	//console.log(cgdLh + " --- " + cgdH + " --- " + numOfLines);
  } 	
   	
}

function ra(){
  var ra = jQuery(".mainMenu #brandsMenu > a").width();
jQuery(".logo").css("max-width", ra);
}


jQuery(document).ready( function() {
  if(jQuery(".expertContainer").length == 1) {
    if(jQuery(window).width() <= 569) {
      if(jQuery(".bioFirstPart").height() > 60){
        jQuery("#readmore").show();
        
        $('#readmore .btn_read_more').click(function(e){
          var cgd = jQuery(".expertContainer .toggle_part1");
          cgd.css("height","auto");       
          $('.btn_read_more').hide();
          $('.btn_read_less').show();
        });

        $('.btn_read_less').click(function(e){
          var cgd = jQuery(".expertContainer .toggle_part1");       
          $('.btn_read_more').show();
          $('.btn_read_less').hide();
          $('.toggle_part1').css('height','60px');
          e.preventDefault();  
        });  

        
      }
    } 
  }
});


 



//Sameheight
/*
* jquery-match-height 0.7.0 by @liabru
* http://brm.io/jquery-match-height/
* License MIT
*/
!function(t){"use strict";"function"==typeof define&&define.amd?define(["jquery"],t):"undefined"!=typeof module&&module.exports?module.exports=t(require("jquery")):t(jQuery)}(function(t){var e=-1,o=-1,i=function(t){return parseFloat(t)||0},a=function(e){var o=1,a=t(e),n=null,r=[];return a.each(function(){var e=t(this),a=e.offset().top-i(e.css("margin-top")),s=r.length>0?r[r.length-1]:null;null===s?r.push(e):Math.floor(Math.abs(n-a))<=o?r[r.length-1]=s.add(e):r.push(e),n=a}),r},n=function(e){var o={
byRow:!0,property:"height",target:null,remove:!1};return"object"==typeof e?t.extend(o,e):("boolean"==typeof e?o.byRow=e:"remove"===e&&(o.remove=!0),o)},r=t.fn.matchHeight=function(e){var o=n(e);if(o.remove){var i=this;return this.css(o.property,""),t.each(r._groups,function(t,e){e.elements=e.elements.not(i)}),this}return this.length<=1&&!o.target?this:(r._groups.push({elements:this,options:o}),r._apply(this,o),this)};r.version="0.7.0",r._groups=[],r._throttle=80,r._maintainScroll=!1,r._beforeUpdate=null,
r._afterUpdate=null,r._rows=a,r._parse=i,r._parseOptions=n,r._apply=function(e,o){var s=n(o),h=t(e),l=[h],c=t(window).scrollTop(),p=t("html").outerHeight(!0),d=h.parents().filter(":hidden");return d.each(function(){var e=t(this);e.data("style-cache",e.attr("style"))}),d.css("display","block"),s.byRow&&!s.target&&(h.each(function(){var e=t(this),o=e.css("display");"inline-block"!==o&&"flex"!==o&&"inline-flex"!==o&&(o="block"),e.data("style-cache",e.attr("style")),e.css({display:o,"padding-top":"0",
"padding-bottom":"0","margin-top":"0","margin-bottom":"0","border-top-width":"0","border-bottom-width":"0",height:"100px",overflow:"hidden"})}),l=a(h),h.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||"")})),t.each(l,function(e,o){var a=t(o),n=0;if(s.target)n=s.target.outerHeight(!1);else{if(s.byRow&&a.length<=1)return void a.css(s.property,"");a.each(function(){var e=t(this),o=e.attr("style"),i=e.css("display");"inline-block"!==i&&"flex"!==i&&"inline-flex"!==i&&(i="block");var a={
display:i};a[s.property]="",e.css(a),e.outerHeight(!1)>n&&(n=e.outerHeight(!1)),o?e.attr("style",o):e.css("display","")})}a.each(function(){var e=t(this),o=0;s.target&&e.is(s.target)||("border-box"!==e.css("box-sizing")&&(o+=i(e.css("border-top-width"))+i(e.css("border-bottom-width")),o+=i(e.css("padding-top"))+i(e.css("padding-bottom"))),e.css(s.property,n-o+"px"))})}),d.each(function(){var e=t(this);e.attr("style",e.data("style-cache")||null)}),r._maintainScroll&&t(window).scrollTop(c/p*t("html").outerHeight(!0)),
this},r._applyDataApi=function(){var e={};t("[data-match-height], [data-mh]").each(function(){var o=t(this),i=o.attr("data-mh")||o.attr("data-match-height");i in e?e[i]=e[i].add(o):e[i]=o}),t.each(e,function(){this.matchHeight(!0)})};var s=function(e){r._beforeUpdate&&r._beforeUpdate(e,r._groups),t.each(r._groups,function(){r._apply(this.elements,this.options)}),r._afterUpdate&&r._afterUpdate(e,r._groups)};r._update=function(i,a){if(a&&"resize"===a.type){var n=t(window).width();if(n===e)return;e=n;
}i?-1===o&&(o=setTimeout(function(){s(a),o=-1},r._throttle)):s(a)},t(r._applyDataApi),t(window).bind("load",function(t){r._update(!1,t)}),t(window).bind("resize orientationchange",function(t){r._update(!0,t)})});



$(function() {
    $('.otherArticlesPreview .articleCol').matchHeight({
    byRow: true,
    property: 'height',
    target: null,
    remove: false
   });
});



 